import React from "react";
import imageCompression from "browser-image-compression";
import A from "../utils/url.utils";

export default function useImage() {
  const bytesToSize = (bytes) => {
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 Byte";
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
  };

  const isBase64 = (str) => {
    return Boolean(str?.includes("base64"));
  };

  // const imageUrl = (url, hostUrl) => {
  //   return url && url.includes("digitaloceanspaces") ? url : hostUrl + url;
  // };

  const compressImage = async (imageInput, options = {}) => {
    try {
      // Handle different input types
      let imageFile;

      if (imageInput instanceof Blob) {
        // If it's already a Blob/File, create a proper File object
        imageFile = new File([imageInput], "image.jpg", {
          type: imageInput.type || "image/jpeg",
          lastModified: Date.now(),
        });
      } else if (typeof imageInput === "string" && imageInput.includes("base64")) {
        // Handle base64 string
        const response = await fetch(imageInput);
        const blob = await response.blob();
        imageFile = new File([blob], "image.jpg", {
          type: blob.type || "image/jpeg",
          lastModified: Date.now(),
        });
      } else if (typeof imageInput === "string") {
        // Handle URL string
        const response = await fetch(imageInput);
        const blob = await response.blob();
        imageFile = new File([blob], "image.jpg", {
          type: blob.type || "image/jpeg",
          lastModified: Date.now(),
        });
      } else {
        throw new Error("Unsupported image input type");
      }

      // Default compression options
      const defaultOptions = {
        maxSizeMB: 0.8,
        maxWidthOrHeight: 800,
        useWebWorker: true,
        initialQuality: 0.8,
      };

      // Compress the image
      const compressedFile = await imageCompression(imageFile, { ...defaultOptions, ...options });

      return compressedFile;
    } catch (error) {
      console.error("Image compression failed:", error);
      throw error;
    }
  };

  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const imageUrl = (url) => (url && url.includes("digitaloceanspaces") ? url : A.HOST + url);

  const imageUrlCheck = (url) => (url && url.includes("digitaloceanspaces") ? url : "");

  const getBase64FileName = (input, defaultName = "image") => {
    // Check if input is a valid DigitalOcean URL
    const validUrl = imageUrlCheck(input);

    if (validUrl) {
      const fileName = validUrl.split("/").pop() || `${defaultName}.unknown`;
      return fileName;
    } else {
      const match = input?.match(/^data:image\/(png|jpeg|jpg|gif|webp);base64,/);
      if (match) {
        return `${defaultName}.${match[1]}`; // Example: image.png
      }
      return `${defaultName}.unknown`; // Fallback if MIME type is missing
    }
  };

  const base64Size = (base64String) => {
    let length = base64String?.length;
    let padding = (base64String?.match(/=/g) || [])?.length;
    let bytes = (length * 3) / 4 - padding;

    if (bytes < 1024) {
      return `${bytes.toFixed(0)} B`;
    } else if (bytes < 1024 * 1024) {
      return `${(bytes / 1024).toFixed(2)} KB`;
    } else {
      return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
    }
  };

  return {
    compressImage,
    bytesToSize,
    blobToBase64,
    imageUrl,
    isBase64,
    imageUrlCheck,
    getBase64FileName,
    base64Size,
  };
}
